export default __webpack_public_path__ + "static/media/Тарбагатайский район ВКО.bda69841.svg";